export const SET_COUNTRIES = 'countries/set-countries';
export const UNSET_COUNTRIES = 'countries/unset-countries';
export const SET_ZIP_CODE_LIST = 'countries/zip-code-list';
export const SET_STATE_DATA = 'countries/state-data';
export const SET_ADDRESS_DATA = 'countries/address-data';
